import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReportsActions from '../../redux/ReportsRedux';
import PageWithTable from '../../components/PageWithTable';
import DateCell from '../../components/DateCell';
import Button from '@atlaskit/button';
import ArrowDownIcon from '@atlaskit/icon/glyph/arrow-down';
import TrashIcon from '@atlaskit/icon/glyph/trash';
import {shortFullName} from '../../helpers/string';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';
import ReportActions from '../../redux/ReportRedux';
import DictionariesActions from '../../redux/DictionariesRedux';

const columns = t => ([
  {
    key: 'title',
    dataKey: 'title',
    title: t('Name'),
    sortable: true,
    minWidth: 320,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'author.dealer.name',
    dataKey: 'author.dealer.name',
    title: t('Dealer'),
    sortable: true,
    width: 140,
  },
  {
    key: 'author.fullName',
    dataKey: 'author.fullName',
    title: t('Author'),
    sortable: true,
    width: 140,
    cellRenderer: ({cellData}) => (shortFullName(cellData))
  },
  {
    key: 'createdAt',
    dataKey: 'createdAt',
    title: t('Creation date'),
    sortable: true,
    width: 160,
    cellRenderer: ({cellData}) => (
      <DateCell date={cellData} />
    ),
  },
  {
    key: 'isReady',
    dataKey: 'isReady',
    title: t('File'),
    sortable: true,
    width: 70,
    style: {padding: 0},
    cellRenderer: props => (
      <Button
        isDisabled={!props.cellData}
        iconBefore={<ArrowDownIcon size='small' />}
        href={`${process.env.REACT_APP_API_URL}reports/${props.rowData && props.rowData.guid}/download`}
        onClick={e => {
          e.stopPropagation()
        }}
      >
        .xls
      </Button>
    ),
  },
]);

class ReportsPage extends Component {
  render() {
    const {
      reports,
      fetching,
      totalPages,
      getReports,
      deleteReport,
      dictionaries,
      getDictionaries,
      reportFetching,
      permissions,
      t,
    } = this.props;

    if (!permissions.reports) {
      return <Forbidden />;
    }

    let dataColumns = columns(t);
    if (permissions.report && permissions.report.delete) {
      dataColumns = [...dataColumns, {
        key: 'remove',
        dataKey: 'remove',
        title: '',
        sortable: false,
        width: 42,
        style: {padding: 0},
        cellRenderer: props => (
          <Button
            appearance='link'
            spacing='compact'
            isLoading={reportFetching}
            onClick={e => {
              e.stopPropagation();
              deleteReport(props.rowData && props.rowData.id);
            }}
          >
            <TrashIcon primaryColor='red'/>
          </Button>
        ),
      }];
    }

    return (
      <PageWithTable
        actionButton={{
          title: t('New report'),
          href: '/reports/new',
        }}
        filterByDatePlaceholder={t('By date')}
        filterByDate={true}
        filters={[
          {
            keyName: 'companyIds',
            placeholder: t('By dealers'),
            data: dictionaries.companies.data,
            fetching: dictionaries.companies.fetching,
            getData: getDictionaries('companies'),
          }
        ]}
        dataColumns={dataColumns}
        data={reports}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={getReports}
        {...this.props}
        permissions={permissions.report}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    reports: state.reports.data,
    totalPages: state.reports.totalPages,
    fetching: state.reports.fetching,
    reportFetching: state.report.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getReports: params => dispatch(ReportsActions.reportsRequest(params)),
    deleteReport: id => dispatch(ReportActions.reportDeleteRequest(id)),
    getDictionaries: (name, query) => () => dispatch(DictionariesActions.dictionariesRequest(name, query)),
  };
};

export default withTranslation('reports', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportsPage));
